import { useEffect, useState } from 'react'

import { MultiFileUploader } from '@/components/file'
import Autocomplete from '@/components/FormInteraction/Autocomplete'
import { customsV2Service } from '@/services'
import { HouseBillSchema } from '@/services/CustomsV2Service'
import { useUIStore } from '@/stores/useUIStore'

type HouseBillOption = { value: number; label: string }

const FileBrowsing: React.FC = () => {
  const { showError } = useUIStore()
  const [isLoading, setIsLoading] = useState(false)
  const [houseBills, setHouseBills] = useState<HouseBillSchema[]>([])
  const [selected, setSelected] = useState<HouseBillOption | null>(null)

  // 加载子提单列表
  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true)
      try {
        const { success, message, data } =
          await customsV2Service.fetchHouseBills()
        if (success && data) {
          setHouseBills(data)
        } else {
          showError(message)
        }
      } finally {
        setIsLoading(false)
      }
    }
    loadData()
  }, [showError])

  // 处理选择变化
  const handleChange = (value: HouseBillOption | HouseBillOption[] | null) => {
    setSelected(Array.isArray(value) ? null : value)
  }

  // 获取当前选中的提单对象
  const selectedBill = houseBills.find((bill) => bill.id === selected?.value)

  // 生成文件存储路径
  const uploadFolder = selectedBill
    ? `customs/master-bills/${selectedBill.masterBill?.masterBlNumber}/house-bills/${selectedBill.houseBlNumber}`
    : undefined

  return (
    <div className="space-y-6">
      <Autocomplete<HouseBillOption>
        options={houseBills.map((bill) => ({
          value: bill.id,
          label: bill.houseBlNumber
        }))}
        value={selected}
        onChange={handleChange}
        placeholder="请输入House Bill Number进行搜索..."
        isLoading={isLoading}
        required
      />

      {selectedBill && uploadFolder && (
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">
            文件管理 - {selectedBill.houseBlNumber}
          </label>
          <MultiFileUploader
            folder={uploadFolder}
            accept="image/*,.pdf"
            maxSize={5 * 1024 * 1024}
            maxFiles={10}
            autoUpload={false}
            enableUpload
          />
        </div>
      )}

      {!selected && !isLoading && (
        <div className="text-center py-8 text-gray-500">
          <p>请先选择一个子提单号以开始文件管理</p>
        </div>
      )}
    </div>
  )
}

export default FileBrowsing
